module.exports = __webpack_public_path__ + "static/img/banner_login_3.e014615.png";


//////////////////
// WEBPACK FOOTER
// ./src/_app/wwka/src/assets/image/banner_login_3.png
// module id = 0VMt
// module chunks = 63